package com.kinoshazam.uiKit.components.textField.filter

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import androidx.compose.ui.text.input.TextFieldValue

@Immutable
fun interface InputFilter {

    fun filter(input: TextFieldValue): TextFieldValue

    companion object {

        @Stable
        val None: InputFilter = InputFilter { input -> input }
    }
}